import { Injectable, Optional, Inject, InjectionToken } from '@angular/core';
import { UploadInput, UploadConfig } from '../model/index';


export interface FFileUploadServerConfig extends UploadConfig {
    upload?: UploadInput | null;
    remove?: UploadInput | null;
}

export const FFileUploadAPIServiceToken = new InjectionToken<FFileUploadServerConfig>('MFFileUploadServerConfig');

@Injectable({
    providedIn: 'root'
})
export class FFileUploadAPIService {
    private config: FFileUploadServerConfig;
    private commonAPI: UploadInput;
    private apiArray = ['upload','remove'];
    constructor(@Optional() @Inject(FFileUploadAPIServiceToken) exConfig: FFileUploadServerConfig) {

        this.config = { upload: null,  remove: null };
        this.commonAPI = { type: 'config', url: '', timeout: 0, headers: null, data: {} };
        if (exConfig) {
            for (const key in this.commonAPI) {
                if (exConfig.hasOwnProperty(key)) {
                    this.commonAPI[key] = exConfig[key];
                }
            }
        }
        this.apiArray.forEach(item => {
            this.config[item] = Object.assign({}, this.commonAPI);
            if (exConfig && exConfig.hasOwnProperty(item)) {
                if (exConfig[item].hasOwnProperty('url')) {
                    this.config[item] = Object.assign({}, this.config[item], exConfig[item], { url: this.combinUrl(exConfig[item].url) });
                }
            }
        });

        // if (exConfig) {
        //     Object.assign(this.config, exConfig);
        // }
    }
    private combinUrl(typeUrl) {
        let result = typeUrl;
        result = this.commonAPI.url + typeUrl;
        return result;
    }
    /**
     * 获取API定义
     */
    getAPI() {
        return this.config;
    }
    /**
     * @param type 
     * @param object 
     */
    getAssignAPI(type, object) {
        // removeAll,uploadAll 用于内部传递使用，应当传递的是remove和upload对应的参数
        // 通过设置对应关系
        const infoMap = { 'removeAll': 'remove', 'uploadAll': 'upload','multipartUpload':'upload' };
        if(infoMap.hasOwnProperty(type)){
            type=infoMap[type];
        }
        if (this.config[type] && object) {
            return Object.assign({}, this.config[type], object);
        }
        if (this.config[type]) {
            return this.config[type];
        }
        if (object) {
            return object;
        }
        return null;

    }
}
